import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';

// Cập nhật lại Component con
const BlockGroupActions = ({ onAddBlock, onDeleteGroup }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <>
            <IconButton onClick={handleClick} size="small" sx={{ color: 'inherit' }}>
                <MoreVertIcon />
            </IconButton>
            <Menu 
                anchorEl={anchorEl} 
                open={open} 
                onClose={handleClose}
                PaperProps={{
                    sx: { boxShadow: '0px 4px 20px rgba(0,0,0,0.1)', borderRadius: '10px' }
                }}
            >
                <MenuItem onClick={() => { onAddBlock(); handleClose(); }}>
                    <ListItemIcon>
                        <AddIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Thêm block</ListItemText>
                </MenuItem>

                <MenuItem onClick={() => { onDeleteGroup(); handleClose(); }}>
                    <ListItemIcon>
                        <DeleteOutlineIcon fontSize="small" sx={{ color: 'error.main' }} />
                    </ListItemIcon>
                    <ListItemText sx={{ color: 'error.main' }}>Xóa</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
};

export default BlockGroupActions;